import React, {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';

/* import cancelIcon from "../../../img/icon/icon-cancel.svg"; */
import { isObjEmpty,ExecuteLogout } from '../../../components/common/Common';

//최초 로그인시 약관동의
const AgreeCondition = ({varPopupAgreeWin,setPopupAgreeWin,onPopupConditionHandler}) => {
  const mem_idx = Number(localStorage.getItem('mem_idx'));
  const navigate = useNavigate();
  const [varConditions,setConditions] = useState({});

  //페이지 정보 표시 - 최초
  useEffect(() => {
    setConditions({all_items:1,term_condition:1,term_privacy:1,term_refund:1,term_marketing:1});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //체크박스
  const onChangeConditionHandler = (e) => {
    const { name } = e.currentTarget;
    const ichecked = Number(e.currentTarget.checked);
    const conItems = document.querySelectorAll('.con-item');

    if(name === "all_items") {
      setConditions({all_items:ichecked,term_condition:ichecked,term_privacy:ichecked,term_refund:ichecked,term_marketing:ichecked});
    } else {
      let ichk = 0;
      for(var j=0; j < conItems.length; j++) {
        if(conItems[j].checked) ichk++;
      }
      let icheck = 1;
      if(ichk < conItems.length) icheck = 0;
      setConditions({...varConditions,all_items:icheck,[name]:ichecked});
    }
  }

  //팝업창 닫기
/*   const onClosePopupHandler = (e) => {
    setPopupAgreeWin(false);
  } */

  //약관동의 저장
  const onUpdateConditionHandler = async(e) => {
    if(varConditions.all_items===0) {
      alert('약관에 전부 동의하셔야 합니다.'); return false;
    }
    const sendData = {mem_idx:mem_idx,conditions:varConditions};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_update_conditions`,sendData).then((res) => {
      const datas = res.data;
      if(datas.retvalue === 1) {
        localStorage.setItem("mem_status",1);
        setPopupAgreeWin(false);
      } else {
        alert(datas.message);
      }
    });
  }

  //팝업창 닫기
  const onCancelConditionHandler = (e) => {
    if(window.confirm('서비스 이용 약관에 동의하지 않으면 앱을 사용할 수 없습니다.')) {
      //앱종료 로직
      setPopupAgreeWin(false);
      ExecuteLogout();
      navigate('/Parents/Login');
      return false;
    } else {
      setPopupAgreeWin(false);
    } 
  }

  return isObjEmpty(varConditions)?null:(
    <>
      <div className={varPopupAgreeWin?"layer-bg open":"layer-bg"}></div>
      <div className={varPopupAgreeWin?"layer-pop open":"layer-pop"} style={{height:"500px"}}>
        <div className="layer-con">
            <div className="layer-hd">
              <div className="tit">서비스 이용약관 동의</div>
              {/* <div className="close-layer" onClick={e=>onClosePopupHandler(e)}><img src={cancelIcon} alt=""/></div> */}
            </div>
            <div className="info">마마몽떼 서비스를 제공받기 위해 다음과 같은 약관에 동의하셔야 정상적인 서비스 이용이 가능합니다.</div>

            <div className="term-check-wrap">
              <div className="term-all">
                <div className="checkbox">
                  <input type="checkbox" name="all_items" id="all_items" checked={varConditions.all_items} onChange={e=>onChangeConditionHandler(e)}/>
                  <label htmlFor="all_items">서비스 이용약관 전체동의</label>
                </div>
              </div>
              <ul className="term-list">
                <li className="term-item">
                  <div className="checkbox">
                    <input type="checkbox" className="con-item" name="term_condition" id="term_condition" checked={varConditions.term_condition} onChange={e=>onChangeConditionHandler(e)}/>
                    <label htmlFor="term_condition">(필수) 이용약관 동의</label>
                  </div>
                  <button className="btx-text" onClick={e=>onPopupConditionHandler(e,1)}>보기</button>
                </li>
                <li className="term-item">
                  <div className="checkbox">
                    <input type="checkbox" className="con-item" name="term_privacy" id="term_privacy" checked={varConditions.term_privacy} onChange={e=>onChangeConditionHandler(e)}/>
                    <label htmlFor="term_privacy">(필수) 개인정보 처리방침 동의</label>
                  </div>
                  <button className="btx-text" onClick={e=>onPopupConditionHandler(e,2)}>보기</button>
                </li>
                <li className="term-item">
                  <div className="checkbox">
                    <input type="checkbox" className="con-item" name="term_refund" id="term_refund" checked={varConditions.term_refund} onChange={e=>onChangeConditionHandler(e)}/>
                    <label htmlFor="term_refund">(필수) 환불 취소 정책 동의</label>
                  </div>
                  <button className="btx-text" onClick={e=>onPopupConditionHandler(e,3)}>보기</button>
                </li>
                <li className="term-item">
                  <div className="checkbox">
                    <input type="checkbox" className="con-item" name="term_marketing" id="term_marketing" checked={varConditions.term_marketing} onChange={e=>onChangeConditionHandler(e)}/>
                    <label htmlFor="term_marketing">(필수) 마케팅 목적의 개인정보 수집 및 이용동의</label>
                  </div>
                  <button className="btx-text" onClick={e=>onPopupConditionHandler(e,4)}>보기</button>
                </li>
              </ul>
              <p className="info02">필수 항목 약관에 동의하셔야<br/>서비스 이용이 가능합니다.</p>
            </div>
            
            <div className="form-contoller bt-btn">
              <button type="button" className="form-contoller-btn btn-no" onClick={e=>onCancelConditionHandler(e)}>취소</button>
              <button type="button" className="form-contoller-btn btn-yes" onClick={e=>onUpdateConditionHandler(e)}>확인</button>
            </div>
        </div>
      </div>
    </>
  )
}
export default AgreeCondition;